import { FC } from "react";
import TableItem from "./Tableitem/TableItem";

interface Props {
    scoreboard: any[];
}

const Scoreboard: FC<Props> = ({ scoreboard }) => {

    return (
        <div className="scoreboard_table">
            {
                scoreboard?.map((player: any, index: number) => {
                    return <TableItem player={player} key={index} isFirstPlace={index === 0}/>
                })
            }
        </div>
    )
};

export default Scoreboard;